module.exports = __webpack_public_path__ + "img/public/SiteIcons/pinterestIconBlack.svg?d57b73fc";